var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"m-button",class:[
    _vm.type && 'm-button-' + _vm.type,
    _vm.size && 'm-button-' + _vm.size,
    {
      'm-button-type-plain': _vm.plain,
      'm-button-rounded': _vm.round,
      'm-button-block': _vm.block,
      'active': _vm.active,
      'clicked': (_vm.effect && _vm.clicked && !_vm.active)
    }
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f06da356","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/m/button/button.vue
// module id = vMZQ
// module chunks = 90